/**
 * Created by Jie Gao on 2018-09-27.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

export class WildExpansionView extends BaseView {
    private _layer:PIXI.Container;
    private _wildExpansionTL:TimelineLite;
    private _overlayWildExpansions:boolean[][];
    private _reelRowWildExplosions:PIXI.spine.Spine[];
    private _reelRowWildExplosionsOffsets:number[] = [200, 60, -60, -200];
    private _rowReelWildExplosions:PIXI.spine.Spine[];
    private _rowReelWildExplosionsOffsets:number[] = [200, 60, -60, -200];
    private _queuedExplosions:PIXI.Point[];
    private _spineWExpandSymbols:PIXI.spine.Spine[][];

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._layer.addChild(this);
        this._queuedExplosions = [];
    }

    protected initAnimations():void {
        this._spineWExpandSymbols = [];
        for(let i:number = 0; i < 4; i++) {
            const tempSyms:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 4; j++) {
                const spineWExpandSymbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("SpineCarrot"));
                spineWExpandSymbol.position = new PIXI.Point(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                spineWExpandSymbol.visible = false;
                this.addChild(spineWExpandSymbol);
                tempSyms.push(spineWExpandSymbol);
            }
            this._spineWExpandSymbols.push(tempSyms);
        }

        this._rowReelWildExplosions = [];
        const rowReel0WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        rowReel0WildExplosion.rotation = 90 * PIXI.DEG_TO_RAD;
        rowReel0WildExplosion.visible = false;
        this.addChild(rowReel0WildExplosion);
        this._rowReelWildExplosions.push(rowReel0WildExplosion);

        const rowReel1WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        rowReel1WildExplosion.rotation = 90 * PIXI.DEG_TO_RAD;
        rowReel1WildExplosion.visible = false;
        this.addChild(rowReel1WildExplosion);
        this._rowReelWildExplosions.push(rowReel1WildExplosion);

        const rowReel2WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        rowReel2WildExplosion.rotation = 90 * PIXI.DEG_TO_RAD;
        rowReel2WildExplosion.scale.y = -1;
        rowReel2WildExplosion.visible = false;
        this.addChild(rowReel2WildExplosion);
        this._rowReelWildExplosions.push(rowReel2WildExplosion);

        const rowReel3WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        rowReel3WildExplosion.rotation = 90 * PIXI.DEG_TO_RAD;
        rowReel3WildExplosion.scale.y = -1;
        rowReel3WildExplosion.visible = false;
        this.addChild(rowReel3WildExplosion);
        this._rowReelWildExplosions.push(rowReel3WildExplosion);

        this._reelRowWildExplosions = [];

        const reelRow0WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        reelRow0WildExplosion.scale.y = -1;
        reelRow0WildExplosion.visible = false;
        this.addChild(reelRow0WildExplosion);
        this._reelRowWildExplosions.push(reelRow0WildExplosion);

        const reelRow1WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        reelRow1WildExplosion.scale.y = -1;
        reelRow1WildExplosion.visible = false;
        this.addChild(reelRow1WildExplosion);
        this._reelRowWildExplosions.push(reelRow1WildExplosion);

        const reelRow2WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        reelRow2WildExplosion.visible = false;
        this.addChild(reelRow2WildExplosion);
        this._reelRowWildExplosions.push(reelRow2WildExplosion);

        const reelRow3WildExplosion:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildExplosion"));
        reelRow3WildExplosion.visible = false;
        this.addChild(reelRow3WildExplosion);
        this._reelRowWildExplosions.push(reelRow3WildExplosion);
    }

    private getAllExplosionsTL(wildSymbolPosition:PIXI.Point, isRowExplosion:boolean):TimelineLite[] {
        this._queuedExplosions.push(new PIXI.Point(wildSymbolPosition.x, wildSymbolPosition.y));
        const allExplosionsTL:TimelineLite[] = [];
        while(this._queuedExplosions.length > 0) {
            let wildPosition:PIXI.Point = this._queuedExplosions.pop()!;
            let explosionTL:TimelineLite = new TimelineLite();
            if(isRowExplosion == true) {
                explosionTL.add([
                    this.getRowWildExplosionTL(wildPosition.x, wildPosition.y),
                    this.addSpreadingWildToFullRow(wildPosition.x, wildPosition.y)
                ]);
            } else {
                explosionTL.add([
                    this.getReelWildExplosionTL(wildPosition.x, wildPosition.y),
                    this.addSpreadingWildToFullReel(wildPosition.x, wildPosition.y)
                ]);
            }

            allExplosionsTL.push(explosionTL);
        }
        return allExplosionsTL;
    }

    private getBunnieJumpingTL(bonusSymbolPosition:PIXI.Point, wildSymbolPosition:PIXI.Point, queueExplosion:boolean, isRowExplosion:boolean):TimelineLite {
        const bunnieJumpingTL:TimelineLite = new TimelineLite();
        bunnieJumpingTL.add(BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.getReelJumpingBunnieTL(bonusSymbolPosition.x, bonusSymbolPosition.y, wildSymbolPosition.x));
        bunnieJumpingTL.add(BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.getRowJumpingBunnieTL(bonusSymbolPosition.x, bonusSymbolPosition.y, wildSymbolPosition.y));

        return bunnieJumpingTL;
    }

    private sortWildsToClosestBunny(wildSymbolPositions:PIXI.Point[], bunnyPosition:PIXI.Point):PIXI.Point[] {
        const sortedWilds:PIXI.Point[] = [];
        let currentClosestReel:number = 5;
        for(let i:number = 0; i < wildSymbolPositions.length; i++) {
            if(Math.abs(wildSymbolPositions[i].x - bunnyPosition.x) < currentClosestReel) {
                sortedWilds.unshift(wildSymbolPositions[i]);
                currentClosestReel = Math.abs(wildSymbolPositions[i].x - bunnyPosition.x);
            } else {
                sortedWilds.push(wildSymbolPositions[i]);
            }
        }
        return sortedWilds;
    }

    public startPresentation(overlayWildExpansions:boolean[][], bonusSymbolPositions:PIXI.Point[], wildSymbolPositions:PIXI.Point[]):TimelineLite {
        this._overlayWildExpansions = overlayWildExpansions;
        let sortedWildPositions1:PIXI.Point[] = [];
        let sortedWildPositions2:PIXI.Point[] = [];
        if(this._wildExpansionTL && this._wildExpansionTL.isActive()) {
            this._wildExpansionTL.pause();
            this._wildExpansionTL.kill();
        }
        this._wildExpansionTL = new TimelineLite();
        //Add jumping Bonus sym(s) and change state on Reel Bonus sym to empty
        for(let i:number = 0; i < bonusSymbolPositions.length; i++) {
            Reels.getSymbol(bonusSymbolPositions[i].x, bonusSymbolPositions[i].y)!.replaceWith("BEmpty", bonusSymbolPositions[i].x);
        }

        //If only one wild and 2 B, the Bs has to wait for each other.
        if(wildSymbolPositions.length == 1 && bonusSymbolPositions.length == 2) {
            sortedWildPositions1 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[0]);
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[0], false, false));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.changeWildState(sortedWildPositions1[0].x, sortedWildPositions1[0].y, "active"))
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[0].x, bonusSymbolPositions[0].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions1[0], false), "-=0.05");
            sortedWildPositions2 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[1]);
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[1], sortedWildPositions2[0], false, true));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAllWildAnimations());
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[1].x, bonusSymbolPositions[1].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions2[0], true), "-=0.05");
        }

        //If one B and 1-3 Wilds
        if(bonusSymbolPositions.length == 1) {
            sortedWildPositions1 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[0]);
            for(let i:number = 0; i < sortedWildPositions1.length - 1; i++) {
                this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[i], true, false));
                this._wildExpansionTL.add(() => this.explodeCarrot(sortedWildPositions1[i], false));
                this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetWildAnimation(sortedWildPositions1[i].x, sortedWildPositions1[i].y));
            }
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[sortedWildPositions1.length - 1], false, false));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAllWildAnimations());
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[0].x, bonusSymbolPositions[0].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions1[sortedWildPositions1.length - 1], false), "-=0.05");
        }

        //If 2 B and 2 Wild
        if(bonusSymbolPositions.length == 2 && wildSymbolPositions.length == 2) {
            //Reel rabbit
            sortedWildPositions1 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[0]);
            for(let i:number = 0; i < sortedWildPositions1.length - 1; i++) {
                this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[i], true, false));
                this._wildExpansionTL.add(() => this.explodeCarrot(sortedWildPositions1[i], false));
                this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.changeWildState(sortedWildPositions1[i].x, sortedWildPositions1[i].y, "active"))
            }
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[sortedWildPositions1.length - 1], false, false));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.changeWildState(sortedWildPositions1[sortedWildPositions1.length - 1].x, sortedWildPositions1[sortedWildPositions1.length - 1].y, "active"))
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[0].x, bonusSymbolPositions[0].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions1[sortedWildPositions1.length - 1], false), "-=0.05");
            //Row rabbit
            sortedWildPositions2 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[1]);
            for(let i:number = 0; i < sortedWildPositions2.length - 1; i++) {
                this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[1], sortedWildPositions2[i], true, true));
                this._wildExpansionTL.add(() => this.explodeCarrot(sortedWildPositions2[i], true));
                this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetWildAnimation(sortedWildPositions2[i].x, sortedWildPositions2[i].y));
            }
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[1], sortedWildPositions2[sortedWildPositions2.length - 1], false, true));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAllWildAnimations());
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[1].x, bonusSymbolPositions[1].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions2[sortedWildPositions2.length - 1], true), "-=0.05");
        }

        //If 3 B and 1 Wild
        if(bonusSymbolPositions.length == 3 && wildSymbolPositions.length == 1) {
            //Reel rabbit
            sortedWildPositions1 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[0]);
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[0], sortedWildPositions1[0], false, false));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.changeWildState(sortedWildPositions1[0].x, sortedWildPositions1[0].y, "active"))
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[0].x, bonusSymbolPositions[0].y));
            this._wildExpansionTL.add(this.getAllExplosionsTL(sortedWildPositions1[0], false), "-=0.05");

            //Row rabbit
            sortedWildPositions2 = this.sortWildsToClosestBunny(wildSymbolPositions, bonusSymbolPositions[1]);
            this._wildExpansionTL.add(this.getBunnieJumpingTL(bonusSymbolPositions[1], sortedWildPositions2[0], false, true));
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAllWildAnimations());
            this._wildExpansionTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.resetAndHideBunnie(bonusSymbolPositions[1].x, bonusSymbolPositions[1].y));
            this._wildExpansionTL.add([
                this.getAllExplosionsTL(sortedWildPositions2[0], true), "-=0.05",
                () => BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.activateHideBunnieanimation(bonusSymbolPositions[2].x, bonusSymbolPositions[2].y)
            ]);
            this._wildExpansionTL.add(new TimelineLite({delay : 1.8}));
        }

        return this._wildExpansionTL;
    }

    private explodeCarrot(wildSymbolPosition:PIXI.Point, isRowExplosion:boolean):void {
        this.getAllExplosionsTL(wildSymbolPosition, isRowExplosion);
    }

    private getReelWildExplosionTL(reel:number, row:number):TimelineLite {
        const wildExplosionTL:TimelineLite = new TimelineLite();
        wildExplosionTL.add(() => this._reelRowWildExplosions[row].position.x = Helper.getSymbolPositions(reel, row)[0]);
        wildExplosionTL.add(() => this._reelRowWildExplosions[row].position.y = Helper.getSymbolPositions(reel, row)[1]);
        wildExplosionTL.add(() => this._reelRowWildExplosions[row].position.y += this._reelRowWildExplosionsOffsets[row]);
        wildExplosionTL.add(() => this._reelRowWildExplosions[row].updateTransform());
        wildExplosionTL.add(() => this._reelRowWildExplosions[row].visible = true);
        if(row == 0 || row == 3) {
            wildExplosionTL.add([
                new SpineTween(this._reelRowWildExplosions[row], 0, "expandB", 0),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_EXPLODE)
            ]);
        } else {
            wildExplosionTL.add([
                new SpineTween(this._reelRowWildExplosions[row], 0, "expandA", 0),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_EXPLODE)
            ]);
        }
        return wildExplosionTL;
    }

    private getRowWildExplosionTL(reel:number, row:number):TimelineLite {
        const wildExplosionTL:TimelineLite = new TimelineLite();
        wildExplosionTL.add(() => this._rowReelWildExplosions[reel].position.x = Helper.getSymbolPositions(reel, row)[0]);
        wildExplosionTL.add(() => this._rowReelWildExplosions[reel].position.y = Helper.getSymbolPositions(reel, row)[1]);
        wildExplosionTL.add(() => this._rowReelWildExplosions[reel].position.x += this._rowReelWildExplosionsOffsets[reel]);
        wildExplosionTL.add(() => this._rowReelWildExplosions[reel].updateTransform());
        wildExplosionTL.add(() => this._rowReelWildExplosions[reel].visible = true);
        if(reel == 0 || reel == 3) {
            wildExplosionTL.add([
                new SpineTween(this._rowReelWildExplosions[reel], 0, "expandB", 0),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_EXPLODE)
            ]);
        } else {
            wildExplosionTL.add([
                new SpineTween(this._rowReelWildExplosions[reel], 0, "expandA", 0),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_EXPLODE)
            ]);
        }
        return wildExplosionTL;
    }

    private addSpreadingWildToFullReel(reelId:number, row:number):TimelineLite {
        const wildToFullReelTL:TimelineLite = new TimelineLite({delay : 0.5});
        if(row == 0) {
            // Go all the way from up to down
            for(let i:number = 0; i < 4; i++) {
                wildToFullReelTL.add(this.getCarrotExplosionTL(reelId, i, (0.05 * i)));
            }
        } else if(row == 3) {
            // Go all the way from down to up
            for(let i:number = 3; i > -1; i--) {
                wildToFullReelTL.add(this.getCarrotExplosionTL(reelId, i, (0.05 * (3 - i))));
            }
        } else {
            //Wild explode
            wildToFullReelTL.add(this.getCarrotExplosionTL(reelId, row, 0));
            //One up and one down
            wildToFullReelTL.add([
                this.getCarrotExplosionTL(reelId, row - 1, 0.05),
                this.getCarrotExplosionTL(reelId, row + 1, 0)
            ]);
            if(row == 1) {
                //Last one down
                wildToFullReelTL.add(this.getCarrotExplosionTL(reelId, row + 2, 0.10));
            } else {
                //Last one up
                wildToFullReelTL.add(this.getCarrotExplosionTL(reelId, row - 2, 0.10));
            }
        }

        wildToFullReelTL.add(this.cleanUpSpreadingReelWild(reelId), "+=0.4");

        return wildToFullReelTL;
    }

    private getCarrotExplosionTL(reel:number, row:number, delay:number):TimelineLite {
        const carrotExplosionTL:TimelineLite = new TimelineLite({delay : delay});
        const tempSym:StateReelSymbol = Reels.getSymbol(reel, row)!;
        if(tempSym.symName !== "BEmpty") {
            carrotExplosionTL.add(() => this._spineWExpandSymbols[reel][row].updateTransform());
            carrotExplosionTL.add(() => this._spineWExpandSymbols[reel][row].visible = true);
            carrotExplosionTL.add(() => tempSym.setVisibility(false));
            carrotExplosionTL.add([
                () => this._spineWExpandSymbols[reel][row].state.setAnimation(0, "land", false),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_POP)
            ]);
        }
        return carrotExplosionTL;
    }

    private cleanUpSpreadingReelWild(reelId:number):TimelineLite {
        const cleanupTL:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < 4; i++) {
            const subCleanupTL:TimelineLite = new TimelineLite();
            let sym:StateReelSymbol = Reels.getSymbol(reelId, i)!;
            subCleanupTL.add(() => sym.setVisibility(true));
            subCleanupTL.add(() => sym.replaceWith("WExpand", reelId));
            subCleanupTL.add(() => this._spineWExpandSymbols[reelId][i].visible = false);
            cleanupTL.add(subCleanupTL);
        }
        return cleanupTL;
    }

    private addSpreadingWildToFullRow(reel:number, row:number):TimelineLite {
        const wildToFullReelTL:TimelineLite = new TimelineLite({delay : 0.5});
        if(reel == 0) {
            // Go all the way from left to right
            for(let i:number = 0; i < 4; i++) {
                wildToFullReelTL.add(this.getCarrotExplosionTL(i, row, (0.05 * i)));
            }
        } else if(reel == 3) {
            // Go all the way from right to left
            for(let i:number = 3; i > -1; i--) {
                wildToFullReelTL.add(this.getCarrotExplosionTL(i, row, (0.05 * (3 - i))));
            }
        } else {
            //Wild explode
            wildToFullReelTL.add(this.getCarrotExplosionTL(reel, row, 0));
            //One left and one right
            wildToFullReelTL.add([
                this.getCarrotExplosionTL(reel - 1, row, 0.05),
                this.getCarrotExplosionTL(reel + 1, row, 0)
            ]);
            if(reel == 1) {
                //Last one right
                wildToFullReelTL.add(this.getCarrotExplosionTL(reel + 2, row, 0.10));
            } else {
                //Last one left
                wildToFullReelTL.add(this.getCarrotExplosionTL(reel - 2, row, 0.10));
            }
        }

        wildToFullReelTL.add(this.cleanUpSpreadingRowWild(row), "+=0.4");

        return wildToFullReelTL;
    }

    private cleanUpSpreadingRowWild(rowlId:number):TimelineLite {
        const cleanupTL:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < 4; i++) {
            const subCleanupTL:TimelineLite = new TimelineLite();
            let sym:StateReelSymbol = Reels.getSymbol(i, rowlId)!;
            subCleanupTL.add(() => sym.setVisibility(true));
            subCleanupTL.add(() => {
                if(sym.symName !== "BEmpty") {
                    subCleanupTL.add(() => sym.replaceWith("WExpand", i));
                }
            });
            subCleanupTL.add(() => this._spineWExpandSymbols[i][rowlId].visible = false);
            cleanupTL.add(subCleanupTL);
        }
        return cleanupTL;
    }

    public abort():void {
        this._queuedExplosions = [];

        if(this._wildExpansionTL && this._wildExpansionTL.isActive()) {
            this._wildExpansionTL.pause();
            this._wildExpansionTL.kill();
        }

        for(let i:number = 0; i < this._reelRowWildExplosions.length; i++) {
            this._reelRowWildExplosions[i].visible = false;
        }

        for(let i:number = 0; i < this._rowReelWildExplosions.length; i++) {
            this._rowReelWildExplosions[i].visible = false;
        }

        BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController.abort();

        let tempSym:StateReelSymbol;
        for(let i:number = 0; i < this._overlayWildExpansions.length; i++) {
            for(let j:number = 0; j < this._overlayWildExpansions[i].length; j++) {
                if(this._overlayWildExpansions[i][j] == true) {
                    tempSym = Reels.getSymbol(i, j)!;
                    if(tempSym.symName !== "BEmpty") {
                        tempSym.replaceWith("WExpand", i);
                    }
                }
            }
        }

        for(let i:number = 0; i < this._spineWExpandSymbols.length; i++) {
            for(let j:number = 0; j < this._spineWExpandSymbols[i].length; j++) {
                this._spineWExpandSymbols[i][j].visible = false;
            }
        }
    }
}